import { api } from './authService';

const getEquipments = () => api.get('/equipment');

const getEquipmentsByProject = (project_id) => api.get(`/equipment/by-project/${project_id}`);

/**
 * @description Devuelve la cantidad de equipos asociados a un proyecto específico.
 * Reutiliza el endpoint by-project y cuenta los resultados en el cliente.
 * @param {number | string} project_id - ID del proyecto.
 * @returns {Promise<number>} Cantidad de equipos del proyecto.
 */
const getEquipmentCountByProject = async (project_id) => {
  const response = await api.get(`/equipment/by-project/${project_id}`);
  return Array.isArray(response.data) ? response.data.length : 0;
};

const createEquipment = (data) => api.post('/equipment', data);

const updateEquipment = (equipment_id, data) => api.patch(`/equipment/${equipment_id}`, data);

const deleteEquipment = (equipment_id) => api.delete(`/equipment/${equipment_id}`);

const equipmentService = {
  getEquipments,
  getEquipmentsByProject,
  getEquipmentCountByProject,
  createEquipment,
  updateEquipment,
  deleteEquipment,
};

export default equipmentService;
